<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->

        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-10" align="left">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="card border-none">
                                            <div class="card-body">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <h5>
                                                                Gatepass Mode:
                                                            </h5>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <label>
                                                                <input
                                                                    v-model="
                                                                        gatepasstype
                                                                    "
                                                                    name="gatepasstype"
                                                                    type="radio"
                                                                    class="form-control checker"
                                                                    autocomplete="off"
                                                                    v-bind:value="'existing'"
                                                                    checked
                                                                />
                                                                Existing
                                                            </label>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <label>
                                                                <input
                                                                    v-model="
                                                                        gatepasstype
                                                                    "
                                                                    name="gatepasstype"
                                                                    type="radio"
                                                                    class="form-control checker"
                                                                    autocomplete="off"
                                                                    v-bind:value="'quick'"
                                                                    checked
                                                                />
                                                                Quick
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="card border-none">
                                            <div class="card-body">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <h5>
                                                                Gatepass Type:
                                                            </h5>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <label>
                                                                <input
                                                                    v-model="
                                                                        type
                                                                    "
                                                                    name="type"
                                                                    type="radio"
                                                                    class="form-control checker"
                                                                    autocomplete="off"
                                                                    v-bind:value="'Sales'"
                                                                    checked
                                                                />
                                                                Sales
                                                            </label>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <label>
                                                                <input
                                                                    v-model="
                                                                        type
                                                                    "
                                                                    name="type"
                                                                    type="radio"
                                                                    class="form-control checker"
                                                                    autocomplete="off"
                                                                    v-bind:value="'Service'"
                                                                    checked
                                                                />
                                                                Service
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="gatepasstype == 'existing'">
                            <br />
                            <br />
                            <div class="col-md-12">
                                <div class="card border-none">
                                    <div class="card-body">
                                        <div class="col-md-12">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <h5>Customer Type:</h5>
                                                </div>
                                                <div class="col-md-4">
                                                    <label>
                                                        <input
                                                            v-model="
                                                                customertype
                                                            "
                                                            name="customertype"
                                                            type="radio"
                                                            class="checker"
                                                            autocomplete="off"
                                                            v-bind:value="'b2c'"
                                                            checked
                                                        />
                                                        B2C
                                                    </label>
                                                </div>
                                                <div class="col-md-4">
                                                    <label>
                                                        <input
                                                            v-model="
                                                                customertype
                                                            "
                                                            name="customertype"
                                                            type="radio"
                                                            class="checker"
                                                            autocomplete="off"
                                                            v-bind:value="'b2b'"
                                                            checked
                                                        />
                                                        B2B
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div
                                    class="row"
                                    v-if="gatepasstype == 'existing'"
                                >
                                    <br /><br />
                                    <div class="col-md-3">
                                        <div
                                            class="row"
                                            v-if="customertype == 'b2c'"
                                        >
                                            <label>Customer Info: *</label>
                                            <input
                                                type="number"
                                                placeholder="Search customer using number"
                                                v-model="number"
                                                min="1000000000"
                                                class="form-control"
                                                @keyup.enter="searchCus"
                                            />
                                        </div>
                                        <br />
                                        <div
                                            class="row"
                                            v-if="customertype == 'b2c'"
                                        >
                                            <button
                                                class="btn"
                                                style="
                                                    width: 100% !important;
                                                    color: white !important;
                                                    background-color: #003334 !important;
                                                "
                                                @click="searchCus"
                                            >
                                                <i class="fa fa-search"></i>
                                                Search O2 Customers
                                                <span
                                                    class="right badge badge-success"
                                                    >{{ search_status }}</span
                                                >
                                            </button>
                                        </div>
                                        <br />
                                        <div
                                            class="row"
                                            v-if="customertype == 'b2c'"
                                        >
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="addCus"
                                            >
                                                <i class="fa fa-plus"></i> Add
                                                New Customer
                                            </button>
                                        </div>
                                        <br />
                                        <div
                                            class="row"
                                            v-if="customertype != 'b2c'"
                                        >
                                            <button
                                                class="btn btn-danger"
                                                style="width: 100% !important"
                                                @click="b2bPrompt"
                                            >
                                                <i class="fa fa-search"></i>
                                                Search B2B Customer
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-md-9">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-3 ml-2">
                                                        <div class="row">
                                                            <div
                                                                class="white-box"
                                                                v-if="
                                                                    customertype !=
                                                                        'b2c' &&
                                                                    b2bcustomer !=
                                                                        null
                                                                "
                                                                style="
                                                                    width: 98% !important;
                                                                    background-color: #003334 !important;
                                                                    border-radius: 10px !important;
                                                                    color: white !important;
                                                                    padding: 15px !important;
                                                                "
                                                            >
                                                                <div
                                                                    class="form-group"
                                                                >
                                                                    <h5>
                                                                        NAME:
                                                                    </h5>
                                                                    <h3>
                                                                        {{
                                                                            b2bcustomer.CustomerName
                                                                        }}
                                                                    </h3>
                                                                    <h5>
                                                                        {{
                                                                            b2bcustomer.CustomerCode
                                                                        }}
                                                                    </h5>
                                                                </div>
                                                                <div
                                                                    class="form-group"
                                                                >
                                                                    <h5>
                                                                        PHONE:
                                                                    </h5>
                                                                    <h5>
                                                                        {{
                                                                            b2bcustomer.MobileNumber
                                                                        }}
                                                                    </h5>
                                                                    <h5>
                                                                        EMAIL:
                                                                    </h5>
                                                                    <h5>
                                                                        {{
                                                                            b2bcustomer.Email
                                                                        }}
                                                                    </h5>
                                                                </div>
                                                            </div>

                                                            <div
                                                                class="white-box"
                                                                v-if="
                                                                    customertype ==
                                                                        'b2c' &&
                                                                    customer.name !=
                                                                        null
                                                                "
                                                                style="
                                                                    width: 98% !important;
                                                                    background-color: #003334 !important;
                                                                    border-radius: 10px !important;
                                                                    color: white !important;
                                                                    padding: 15px !important;
                                                                "
                                                            >
                                                                <div
                                                                    class="form-group"
                                                                >
                                                                    <h5>
                                                                        NAME:
                                                                    </h5>
                                                                    <h3>
                                                                        {{
                                                                            customer.name
                                                                        }}
                                                                    </h3>
                                                                </div>
                                                                <div
                                                                    class="form-group"
                                                                >
                                                                    <h5>
                                                                        PHONE:
                                                                    </h5>
                                                                    <h5>
                                                                        {{
                                                                            customer.mobile
                                                                        }}
                                                                        {{
                                                                            customer.alt_mobile
                                                                        }}
                                                                        {{
                                                                            customer.phone
                                                                        }}
                                                                        {{
                                                                            customer.alt_phone
                                                                        }}
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-7 pl-2">
                                                        <div
                                                            class="col-md-12"
                                                            v-if="
                                                                customertype !=
                                                                    'b2c' &&
                                                                b2bcustomer !=
                                                                    null
                                                            "
                                                        >
                                                            <div class="row">
                                                                <div
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    :class="[
                                                                        'form-group',
                                                                        errors.billing_address
                                                                            ? 'has-error'
                                                                            : '',
                                                                    ]"
                                                                >
                                                                    <label
                                                                        >Communication
                                                                        Address
                                                                        *</label
                                                                    >
                                                                    <p
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                    >
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .Address
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .Building
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .Street
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .StreetNo
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .Block
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .City
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .Zipcode
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .State
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .Country
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .BillingAddress
                                                                                .GSTRegNo
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    :class="[
                                                                        'form-group',
                                                                        errors.comm_address
                                                                            ? 'has-error'
                                                                            : '',
                                                                    ]"
                                                                >
                                                                    <label
                                                                        >Shipping
                                                                        Address
                                                                        *</label
                                                                    >
                                                                    <p
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                    >
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .Address
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .Building
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .Street
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .StreetNo
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .Block
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .City
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .Zipcode
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .State
                                                                        }},
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .Country
                                                                        }},
                                                                        <br />
                                                                        {{
                                                                            b2bcustomer
                                                                                .ShipingAddress
                                                                                .GSTRegNo
                                                                        }}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div class="row">
                                                                <div
                                                                    class="form-group"
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    v-if="
                                                                        addaddress ==
                                                                            true &&
                                                                        customertype ==
                                                                            'b2c'
                                                                    "
                                                                >
                                                                    <button
                                                                        class="btn btn-danger"
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                        @click="
                                                                            addCusAddress
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="fa fa-plus"
                                                                        ></i>
                                                                        Add
                                                                        Address
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="col-md-12"
                                                            v-if="
                                                                customertype ==
                                                                'b2c'
                                                            "
                                                        >
                                                            <div class="row">
                                                                <div
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    :class="[
                                                                        'form-group',
                                                                        errors.billing_address
                                                                            ? 'has-error'
                                                                            : '',
                                                                    ]"
                                                                >
                                                                    <label
                                                                        >Communication
                                                                        Address
                                                                        *</label
                                                                    >
                                                                    <select
                                                                        v-model="
                                                                            billing_address
                                                                        "
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                        class="form-control"
                                                                        @change="
                                                                            getStatePrefix
                                                                        "
                                                                    >
                                                                        <option
                                                                            v-for="j in addresses"
                                                                            :key="
                                                                                j.id
                                                                            "
                                                                            :value="
                                                                                j.id
                                                                            "
                                                                        >
                                                                            {{
                                                                                j.addr_l1
                                                                            }},
                                                                            {{
                                                                                j.addr_l2
                                                                            }},
                                                                            {{
                                                                                j.addr_l3
                                                                            }},
                                                                            {{
                                                                                j.city
                                                                            }},
                                                                            {{
                                                                                j.state
                                                                            }},
                                                                            {{
                                                                                j.pincode
                                                                            }}
                                                                        </option>
                                                                        <span
                                                                            v-if="
                                                                                errors.billing_address
                                                                            "
                                                                            :class="[
                                                                                'badge bg-danger',
                                                                            ]"
                                                                            >Please
                                                                            choose
                                                                            an
                                                                            address.</span
                                                                        >
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    :class="[
                                                                        'form-group',
                                                                        errors.comm_address
                                                                            ? 'has-error'
                                                                            : '',
                                                                    ]"
                                                                >
                                                                    <label
                                                                        >Shipping
                                                                        Address
                                                                        *</label
                                                                    >
                                                                    <select
                                                                        v-model="
                                                                            comm_address
                                                                        "
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                        class="form-control"
                                                                    >
                                                                        <option
                                                                            v-for="j in addresses"
                                                                            :key="
                                                                                j.id
                                                                            "
                                                                            :value="
                                                                                j.id
                                                                            "
                                                                        >
                                                                            {{
                                                                                j.addr_l1
                                                                            }},
                                                                            {{
                                                                                j.addr_l2
                                                                            }},
                                                                            {{
                                                                                j.addr_l3
                                                                            }},
                                                                            {{
                                                                                j.city
                                                                            }},
                                                                            {{
                                                                                j.state
                                                                            }},
                                                                            {{
                                                                                j.pincode
                                                                            }}
                                                                        </option>
                                                                        <span
                                                                            v-if="
                                                                                errors.comm_address
                                                                            "
                                                                            :class="[
                                                                                'badge bg-danger',
                                                                            ]"
                                                                            >Please
                                                                            choose
                                                                            an
                                                                            address.</span
                                                                        >
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div
                                                                    class="form-group"
                                                                    style="
                                                                        width: 100% !important;
                                                                    "
                                                                    v-if="
                                                                        addaddress ==
                                                                        true
                                                                    "
                                                                >
                                                                    <button
                                                                        class="btn btn-danger"
                                                                        style="
                                                                            width: 100% !important;
                                                                        "
                                                                        @click="
                                                                            addCusAddress
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="fa fa-plus"
                                                                        ></i>
                                                                        Add
                                                                        Address
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <br />
                                    <br />
                                    <div class="col-md-12 overflow-auto">
                                        <div class="row">
                                            <div
                                                class="col-md-6"
                                                v-if="gatepasstype == 'quick'"
                                            >
                                                <div
                                                    :class="[
                                                        'form-group',
                                                        errors.customer?.name
                                                            ? 'has-error'
                                                            : '',
                                                    ]"
                                                >
                                                    <label>Name:</label>
                                                    <input
                                                        class="form-control"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        v-model="customer.name"
                                                        placeholder="Enter the name"
                                                        type="text"
                                                    />
                                                    <span
                                                        v-if="
                                                            errors.customer
                                                                ?.name
                                                        "
                                                        :class="[
                                                            'badge bg-danger',
                                                        ]"
                                                        >Please enter a valid
                                                        name</span
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6"
                                                v-if="gatepasstype == 'quick'"
                                            >
                                                <div
                                                    :class="[
                                                        'form-group',
                                                        errors[customer.mobile]
                                                            ? 'has-error'
                                                            : '',
                                                    ]"
                                                >
                                                    <label>Mobile:</label>
                                                    <input
                                                        class="form-control"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        v-model="
                                                            customer.mobile
                                                        "
                                                        placeholder="Enter the mobile number"
                                                        type="text"
                                                    />
                                                    <span
                                                        :class="[
                                                            'badge bg-warning',
                                                        ]"
                                                        >Please check if it is a
                                                        correct mobile
                                                        number.</span
                                                    >
                                                    <span
                                                        v-if="
                                                            errors[
                                                                customer.mobile
                                                            ]
                                                        "
                                                        :class="[
                                                            'badge bg-danger',
                                                        ]"
                                                        >Please enter a valid
                                                        number</span
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6"
                                                v-if="gatepasstype == 'quick'"
                                            >
                                                <div
                                                    :class="[
                                                        'form-group',
                                                        errors.customer
                                                            ?.alt_mobile
                                                            ? 'has-error'
                                                            : '',
                                                    ]"
                                                >
                                                    <label
                                                        >Alternate
                                                        Mobile:</label
                                                    >
                                                    <input
                                                        class="form-control"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        v-model="
                                                            customer.alt_mobile
                                                        "
                                                        placeholder="Enter the alternate mobile number"
                                                        type="text"
                                                    />
                                                    <span
                                                        :class="[
                                                            'badge bg-warning',
                                                        ]"
                                                        >Please check if it is a
                                                        correct mobile
                                                        number.</span
                                                    >
                                                    <span
                                                        v-if="
                                                            errors.customer
                                                                ?.alt_mobile
                                                        "
                                                        :class="[
                                                            'badge bg-danger',
                                                        ]"
                                                        >Please enter a valid
                                                        number</span
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Branch:</label>
                                                    <v-select
                                                        v-model="branch"
                                                        :options="branches"
                                                        :reduce="
                                                            (branches) =>
                                                                branches.branch_code
                                                        "
                                                        placeholder="Select destination branch"
                                                        label="fullname"
                                                        @input="getSalesmen"
                                                    ></v-select>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    :class="[
                                                        'form-group',
                                                        errors.product
                                                            ? 'has-error'
                                                            : '',
                                                    ]"
                                                >
                                                    <label>Product:</label>
                                                    <v-select
                                                        v-model="product"
                                                        :options="products"
                                                        label="product_name"
                                                        :reduce="
                                                            (products) =>
                                                                products.product_name
                                                        "
                                                    ></v-select>
                                                    <span
                                                        v-if="errors.product"
                                                        :class="[
                                                            'badge bg-danger',
                                                        ]"
                                                        >Please pick a valid
                                                        product</span
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    :class="[
                                                        'form-group',
                                                        errors.campaign_media
                                                            ? 'has-error'
                                                            : '',
                                                    ]"
                                                >
                                                    <label
                                                        >Campaign Media:</label
                                                    >
                                                    <v-select
                                                        v-model="campaign_media"
                                                        :options="medias"
                                                        label="name"
                                                        :reduce="
                                                            (medias) =>
                                                                medias.id
                                                        "
                                                    ></v-select>
                                                    <span
                                                        v-if="
                                                            errors.campaign_media
                                                        "
                                                        :class="[
                                                            'badge bg-danger',
                                                        ]"
                                                        >Please pick a valid
                                                        campaign media</span
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    :class="[
                                                        'form-group',
                                                        errors.status
                                                            ? 'has-error'
                                                            : '',
                                                    ]"
                                                >
                                                    <label>Status:</label>
                                                    <v-select
                                                        v-model="status"
                                                        :options="gpstatuses"
                                                        label="status"
                                                        :reduce="
                                                            (gpstatuses) =>
                                                                gpstatuses.status
                                                        "
                                                    ></v-select>
                                                    <span
                                                        v-if="errors.status"
                                                        :class="[
                                                            'badge bg-danger',
                                                        ]"
                                                        >Please pick a valid
                                                        status</span
                                                    >
                                                </div>
                                            </div>
                                            <div
                                                class="col-md-6"
                                                v-if="status == 'Lost'"
                                            >
                                                <div class="form-group">
                                                    <label
                                                        >Turnaway Reason:
                                                    </label>
                                                    <v-select
                                                        v-model="
                                                            turnaway_reason
                                                        "
                                                        type="text"
                                                        label="name"
                                                        :options="reasons"
                                                        :reduce="
                                                            (reasons) =>
                                                                reasons.name
                                                        "
                                                        placeholder="Select Reason"
                                                    ></v-select>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    :class="[
                                                        'form-group',
                                                        errors.requirement
                                                            ? 'has-error'
                                                            : '',
                                                    ]"
                                                >
                                                    <label>Requirement:</label>
                                                    <input
                                                        class="form-control"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        v-model="requirement"
                                                        label="Requirement"
                                                        type="text"
                                                    />
                                                    <span
                                                        v-if="
                                                            errors.requirement
                                                        "
                                                        :class="[
                                                            'badge bg-danger',
                                                        ]"
                                                        >Please enter a valid
                                                        requirement</span
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>Assign To:</label>
                                                    <v-select
                                                        v-model="salesman"
                                                        :options="salesmen"
                                                        label="user_detail"
                                                        :reduce="
                                                            (salesmen) =>
                                                                salesmen.id
                                                        "
                                                    ></v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br /><br /><br />
                            </div>
                        </div>
                        <div class="row" align="center">
                            <br /><br /><br />
                            <button
                                class="btn"
                                style="
                                    width: 100% !important;
                                    color: white !important;
                                    background-color: #003334 !important;
                                "
                                @click="createGatepass"
                            >
                                Create Gatepass
                                <i class="fa fa-arrow-right"></i>
                            </button>
                            <br /><br /><br />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <p>
                            <button
                                class="btn btn-primary"
                                style="width: 100% !important"
                            >
                                <i class="fa fa-user"></i> Fetch Caller
                            </button>
                        </p>
                        <br />
                        <p>
                            <button
                                class="btn btn-warning"
                                style="width: 100% !important"
                            >
                                <i class="fa fa-boxes"></i> Check Stock
                            </button>
                        </p>
                        <br />
                        <!--            <p>-->
                        <!--                <button class="btn " style="width: 100% !important; color: white !important; background-color: #003334 !important;" @click="createGatepass"><i class="fa fa-arrow-right"></i> Create Gatepass</button>-->
                        <!--            </p>-->
                        <!--            <br>-->
                    </div>
                    <br /><br /><br />
                    <br /><br /><br />
                </div>
            </div>
            <!-- end -->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="adrsmodal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Customer Address</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-if="allow == true"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateAddress">
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l1 ? 'has-error' : '',
                                ]"
                            >
                                <label>House Name/Building *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 1"
                                    v-model="aform.addr_l1"
                                />
                                <span
                                    v-if="errors.addr_l1"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l2 ? 'has-error' : '',
                                ]"
                            >
                                <label>PO Box/Landmark *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 2"
                                    v-model="aform.addr_l2"
                                />
                                <span
                                    v-if="errors.addr_l2"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l3 ? 'has-error' : '',
                                ]"
                            >
                                <label>Village/Panchayat/District *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 3"
                                    v-model="aform.addr_l3"
                                />
                                <span
                                    v-if="errors.addr_l3"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.state ? 'has-error' : '',
                                ]"
                            >
                                <label>State *</label>
                                <v-select
                                    v-model="state_id"
                                    :options="states"
                                    placeholder="Select State"
                                    label="name"
                                    :reduce="(states) => states.id"
                                    @input="stateChange"
                                ></v-select>
                                <span
                                    v-if="errors.state"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid state.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>City *</label>
                                <v-select
                                    v-model="city_id"
                                    :options="cities"
                                    placeholder="Select City"
                                    label="name"
                                    :reduce="(cities) => cities.id"
                                    @input="cityChange"
                                ></v-select>
                                <span
                                    v-if="errors.city"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid city.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.pincode ? 'has-error' : '',
                                ]"
                            >
                                <label>Pincode *</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Enter pincode"
                                    v-model="aform.pincode"
                                    min="100000"
                                />
                                <span
                                    v-if="errors.pincode"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid pincode.</span
                                >
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            v-if="allow == true"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="cstmrmodal">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Customer Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateCustomer">
                            <div
                                :class="[
                                    'form-group',
                                    errors.name ? 'has-error' : '',
                                ]"
                            >
                                <label>Name *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the customer name"
                                    v-model="form.name"
                                />
                                <span
                                    v-if="errors.name"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid name.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.gender ? 'has-error' : '',
                                ]"
                            >
                                <label>Gender *</label>
                                <select
                                    class="form-control"
                                    placeholder="Select customer gender"
                                    v-model="form.gender"
                                >
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
                                </select>
                                <span
                                    v-if="errors.gender"
                                    :class="['badge bg-danger']"
                                    >Please choose a valid gender.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.mobile ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 1 *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 1"
                                    v-model="form.mobile"
                                />
                                <span
                                    v-if="errors.mobile"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.alt_mobile ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 2</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 2"
                                    v-model="form.alt_mobile"
                                />
                                <span
                                    v-if="errors.alt_mobile"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.phone ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 3</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 3"
                                    v-model="form.phone"
                                />
                                <span
                                    v-if="errors.phone"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.alt_phone ? 'has-error' : '',
                                ]"
                            >
                                <label>Phone 4</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter phone 4"
                                    v-model="form.alt_phone"
                                />
                                <span
                                    v-if="errors.alt_phone"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid phone number.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.email ? 'has-error' : '',
                                ]"
                            >
                                <label>E-mail</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    placeholder="Enter email address"
                                    v-model="form.email"
                                />
                                <span
                                    v-if="errors.email"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid email.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.alt_email ? 'has-error' : '',
                                ]"
                            >
                                <label>Alt E-mail</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter alternate email address"
                                    v-model="form.alt_email"
                                />
                                <span
                                    v-if="errors.alt_email"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid email.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.dob ? 'has-error' : '',
                                ]"
                            >
                                <label>DOB *</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter date of birth"
                                    v-model="form.dob"
                                />
                                <span
                                    v-if="errors.dob"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid dob.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.membership_id ? 'has-error' : '',
                                ]"
                            >
                                <label>Membership ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter membership ID"
                                    v-model="form.membership_id"
                                />
                                <span
                                    v-if="errors.membership_id"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid membership ID.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.category ? 'has-error' : '',
                                ]"
                            >
                                <label>Category</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the category"
                                    v-model="form.category"
                                />
                                <span
                                    v-if="errors.category"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid category.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.area ? 'has-error' : '',
                                ]"
                            >
                                <label>Area</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the area"
                                    v-model="form.area"
                                />
                                <span
                                    v-if="errors.area"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid area.</span
                                >
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Next
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- All</div> VUE Parts end before this comment -->
        </div>

        <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            id="b2bsearchmodal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Search B2B Customer</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <input
                                            type="email"
                                            placeholder="Enter the email"
                                            v-model="b2bemail"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the phone"
                                            v-model="b2bphone"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the name"
                                            v-model="b2bname"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the card code"
                                            v-model="b2bcard"
                                            class="form-control"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            placeholder="Enter the card gst no."
                                            v-model="b2bgst"
                                            class="form-control"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="b2bSearch"
                                        >
                                            Search ERP for B2B Customer
                                            <span
                                                class="right badge badge-success"
                                                >{{ search_status }}</span
                                            >
                                        </button>
                                    </div>
                                </div>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            tabindex="-1"
            role="dialog"
            id="b2bcustomersmodal"
        >
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>Pick Customer</h3>
                        <table class="table table-striped table hover">
                            <thead>
                                <tr>
                                    <th scope="col">Customer Code</th>
                                    <th scope="col">Customer Name</th>
                                    <th scope="col">Customer Group Name</th>
                                    <th scope="col">Mobile Number</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Billing Address</th>
                                    <th scope="col">Shipping Address</th>
                                    <th scope="col">Choose</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="i in b2bcustomers">
                                    <td>{{ i.CustomerCode }}</td>
                                    <td>{{ i.CustomerName }}</td>
                                    <td>{{ i.CustomerGroupName }}</td>
                                    <td>{{ i.MobileNumber }}</td>
                                    <td>{{ i.Email }}</td>
                                    <td>
                                        {{ i.BillingAddress.Address }},
                                        {{ i.BillingAddress.Building }},
                                        {{ i.BillingAddress.Street }},
                                        {{ i.BillingAddress.StreetNo }},
                                        {{ i.BillingAddress.Block }},
                                        {{ i.BillingAddress.City }},
                                        {{ i.BillingAddress.Zipcode }},
                                        {{ i.BillingAddress.State }},
                                        {{ i.BillingAddress.Country }},
                                        {{ i.BillingAddress.GSTRegNo }}
                                    </td>
                                    <td>
                                        {{ i.ShipingAddress.Address }},
                                        {{ i.ShipingAddress.Building }},
                                        {{ i.ShipingAddress.Street }},
                                        {{ i.ShipingAddress.StreetNo }},
                                        {{ i.ShipingAddress.Block }},
                                        {{ i.ShipingAddress.City }},
                                        {{ i.ShipingAddress.Zipcode }},
                                        {{ i.ShipingAddress.State }},
                                        {{ i.ShipingAddress.Country }},
                                        {{ i.ShipingAddress.GSTRegNo }}
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-primary"
                                            @click="selectCustomer(i)"
                                        >
                                            Select
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
    </div>
</template>

<script>
import { parse } from "postcss";
import loading from "vue-full-loading";

export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading },

    created() {
        if (typeof this.$route.params.lead_id !== "undefined") {
            this.lead_id = this.$route.params.lead_id;
            this.gatepasstype = "quick";
            this.getLeadSheetData();
        }
        this.user_type = window.user.user_type;
        this.type = "Sales";
        console.log(this.user_type);
        if (this.user_type == "cc-manager" || this.user_type == "cc-agent")
            this.entrypoint = "CRM";
        else if (
            this.user_type == "online-sales-manager" ||
            this.user_type == "online-sales-associate"
        )
            this.entrypoint = "ECOMMERCE";
        // else if(this.user_type == 'marketing-admin' || this.user_type == 'marketing-manager')
        //     this.entrypoint='ONLINE';
        else this.entrypoint = "POS";
        console.log(this.entrypoint);
        this.getBranches();
        this.getStates();
        this.getGPStatuses();
        this.getProducts();
        this.getCampaignMedias();
        this.getReasons();
        this.getSalesmen();
    },

    data() {
        return {
            customertype: "b2c",
            type: "",
            user_type: "",
            entrypoint: "",
            gatepasstype: "existing",
            form: new Form({
                name: "",
                uid: "",
                gender: "",
                mobile: "",
                alt_mobile: "",
                phone: "",
                alt_phone: "",
                email: "",
                alt_email: "",
                dob: "",
                membership_id: "",
                category: "",
                area: "",
                id: "",
            }),
            errors: [],
            aform: new Form({
                profile_id: "",
                addr_l1: "",
                addr_l2: "",
                addr_l3: "",
                city: "",
                state: "",
                pincode: "",
                id: "",
            }),
            customer: {},
            billing_address: "",
            comm_address: "",
            addresses: [],
            addaddress: false,
            b2bemail: "",
            b2bphone: "",
            b2bname: "",
            b2bcard: "",
            b2bgst: "",
            b2bcustomers: [],
            b2bcustomer: null,
            lshow: false,
            llabel: "",
            number: "",
            status: "",
            states: [],
            state_id: "",
            cities: [],
            products: [],
            linkages: [],
            city_id: "",
            allow: "",
            product: "",
            search_status: "",
            gpstatuses: [],
            gpstatus: "",
            medias: [],
            campaign_media: "",
            requirement: "",
            turnaway_reason: "",
            reasons: [],
            salesmen: [],
            branches: [],
            lead_sheet_data: [],
            branch: "",
            salesman: "",
            returning: "",
        };
    },

    methods: {
        // getSalesmen(){
        // 	axios.post("/api/getBranchCallAgents" , {branch: this.branch})
        // 	.then(response => {
        // 		this.salesmen = response.data;
        // 	})
        // },

        getLeadSheetData() {
            axios
                .post("/api/getLeadSheetItem", { id: this.lead_id })
                .then((response) => {
                    this.gatepasstype = "quick";
                    this.lead_sheet_data = response.data;
                    console.log(this.lead_sheet_data.full_name);
                    this.customer.name = this.lead_sheet_data.full_name;
                    this.customer.mobile = this.lead_sheet_data.phone_number;
                    this.customer.alt_mobile =
                        this.lead_sheet_data.alt_phone_number;
                    this.branch = this.lead_sheet_data.branch_code;
                    this.campaign_media =
                        this.lead_sheet_data.campaign_media_id;
                    this.requirement = this.lead_sheet_data.product;
                });
        },

        getSalesmen() {
            axios.post("/api/getBranchCallAgents").then((response) => {
                this.salesmen = response.data;
            });
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getProducts(url = "/api/getMasterProductList") {
            axios.post(url).then((response) => {
                this.products = response.data;
            });
        },

        getReasons() {
            axios.post("/api/getAllTAR").then((response) => {
                this.reasons = response.data;
            });
        },

        getStates() {
            axios.post("/api/getStates", { country: 101 }).then((response) => {
                this.states = response.data;
            });
        },

        getCities() {
            axios
                .post("/api/getCities", { state: this.state_id })
                .then((response) => {
                    this.cities = response.data;
                });
        },

        getCampaignMedias() {
            axios.post("/api/getCampaignMedias").then((response) => {
                this.medias = response.data;
            });
        },

        getGPStatuses() {
            axios.post("/api/getGPStatuses").then((response) => {
                this.gpstatuses = response.data;
            });
        },

        stateChange() {
            var state = this.states.find((s) => s.id == this.state_id);
            this.aform.state = state.state_code;
            this.getCities();
        },

        getStatePrefix() {
            if (this.customertype == "b2c")
                var state = this.addresses.find(
                    (a) => a.id == this.billing_address
                ).state;
            else var state = this.b2bcustomer.BillingAddress.State;
            axios
                .post("/api/getStatePrefix", { state: state })
                .then((response) => {
                    this.placeofsupply = response.data;
                });
        },

        cityChange() {
            var city = this.cities.find((s) => s.id == this.city_id);
            this.aform.city = city.name;
        },

        itemCodeModal() {
            this.search_status = "";
            $("#itemCodeModal").modal("show");
        },

        searchCus() {
            this.search_sstatus = "Searching...";
            axios
                .post("/api/numberSearchCus", { number: this.number })
                .then((response) => {
                    if (response.data != "") {
                        this.customer = response.data;
                        this.search_status = "Search Complete!";
                        this.getAddresses();
                        this.addaddress = true;
                        this.returning = "Yes";
                    } else {
                        this.returning = "No";
                        this.search_status = "No results. Please add customer!";
                    }
                })
                .catch(() => {
                    this.search_status = "Search Error!";
                });
        },

        addCusAddress() {
            this.aform.profile_id = this.customer.id;
            $("#adrsmodal").modal("show");
        },

        updateCustomer() {
            this.form
                .post("/api/updateCustomerSA")
                .then((response) => {
                    if (response.data != null) {
                        toast.fire({
                            icon: "success",
                            title: "Customer Details Updated",
                        });
                        $("#cstmrmodal").modal("hide");
                        this.form.id = response.data;
                        this.number = this.form.mobile;
                        this.errors = [];
                        this.add();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Operation Failed",
                        });
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Operation Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        updateAddress() {
            this.aform
                .post("/api/addLeadAddress")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Addresses Updated",
                        });
                        this.errors = [];
                        this.allow = true;
                        this.searchCus();
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        getAddresses() {
            axios
                .post("/api/getLeadAddresses", { id: this.customer.id })
                .then((response) => {
                    this.addresses = response.data;
                });
        },

        add() {
            this.aform.profile_id = this.form.id;
            $("#adrsmodal").modal("show");
        },

        addCus() {
            $("#cstmrmodal").modal("show");
        },

        change(address) {
            this.heading = "Edit";
            this.aform.fill(address);
            $("#adrsmodal").modal("show");
        },

        clearForm() {
            window.location.reload();
            // this.$router.go()
        },

        addCustomer() {
            axios
                .post("/api/addCustomerDets", {
                    customer_id: this.customer.id,
                    customer_phone: this.customer.mobile,
                    comm_address: this.comm_address,
                    billing_address: this.billing_address,
                    id: this.job.id,
                    customer_name: this.customer.name,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Job Updated",
                        });
                        this.errors = [];
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        b2bPrompt() {
            $("#b2bsearchmodal").modal("show");
        },

        b2bSearch() {
            this.search_status = "Searching...";
            axios
                .post("/api/getB2BCustomers", {
                    email: this.b2bemail,
                    phone: this.b2bphone,
                    name: this.b2bname,
                    card: this.b2bcard,
                    gst: this.b2bgst,
                })
                .then((response) => {
                    if (response.data != 0) {
                        this.b2bcustomers = response.data;
                        $("#b2bsearchmodal").modal("hide");
                        $("#b2bcustomersmodal").modal("show");
                        this.returning = "Yes";
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "No customers found",
                        });
                        this.returning = "No";
                    }
                    this.search_status = "Searching Complete!";
                });
        },

        selectCustomer(cus) {
            this.b2bcustomer = cus;
            $("#b2bcustomersmodal").modal("hide");
            this.getStatePrefix();
        },
        createGatepass() {
            if (this.gatepasstype === "existing") {
                console.log(this.gatepasstype);
                if (this.customertype == "b2b")
                    var scustomer = this.b2bcustomer;
                else {
                    //console.log(this.addresses.find(a => a.id == this.billing_address));
                    this.customer.billing_address = this.addresses.find(
                        (a) => a.id == this.billing_address
                    );
                    this.customer.shipping_address = this.addresses.find(
                        (a) => a.id == this.comm_address
                    );
                    var scustomer = this.customer;
                }
                axios
                    .post("/api/createGatepassWithAddress", {
                        customer: scustomer,
                        type: this.type,
                        customertype: this.customertype,
                        placeofsupply: this.placeofsupply,
                        entry_point: this.entrypoint,
                        requirement: this.requirement,
                        campaign_media: this.campaign_media,
                        turnaway_reason: this.turnaway_reason,
                        branch: this.branch,
                        status: this.status,
                        returning: this.returning,
                    })
                    .then((response) => {
                        toast.fire({
                            icon: "success",
                            title: "Gatepass Created",
                        });
                        if (this.type == "Service") {
                            if (response.data.status == "Converted") {
                                this.$router.push(
                                    "/service/new-job/" + response.data.id
                                );
                            }
                            console.log(response.data.status);
                        } else {
                            if (response.data.status === "Converted") {
                                console.log(window.user_type + " inside");
                                this.$router.push(
                                    "/create-instant-order/" + response.data.id
                                );
                            }
                        }
                    });
            } else {
                if (this.customertype == "b2b") {
                    var scustomer = this.b2bcustomer;
                    scustomer.status = this.customer.status;
                } else {
                    var scustomer = this.customer;
                }
                axios
                    .post("/api/createGatepass", {
                        customer: scustomer,
                        type: this.type,
                        customertype: this.customertype,
                        placeofsupply: this.placeofsupply,
                        entry_point: this.entrypoint,
                        campaign_media: this.campaign_media,
                        requirement: this.requirement,
                        turnaway_reason: this.turnaway_reason,
                        assigned_to: this.salesman,
                        status: this.status,
                        returning: this.returning,
                        branch: this.branch,
                        product: this.product,
                        ls_id: this.lead_id,
                    })
                    .then((response) => {
                        toast.fire({
                            icon: "success",
                            title: "Gatepass Created",
                        });
                        if (this.type == "Service") {
                            if (response.data.status == "Converted") {
                                this.$router.push(
                                    "/service/new-job/" + response.data.id
                                );
                            }
                            console.log(response.data.status);
                        } else {
                            if (response.data.status === "Converted") {
                                console.log(window.user_type + " inside");
                                this.$router.push(
                                    "/create-instant-order/" + response.data.id
                                );
                            }
                        }
                        console.log(window.user.user_type + " outside");
                        this.errors = [];
                    })
                    .catch((errors) => {
                        this.errors = errors.response.data.errors;
                        toast.fire({
                            title: "Operation Failed",
                            icon: "error",
                        });
                    });
            }
        },
    },
};
</script>
<style>
.header {
    position: sticky;
    top: 0;
}
</style>
